import { Pagination } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useBreakpoint } from 'shared/lib';
import { myBetsModalModel } from '../../model';
import cls from './my-bets-modal-pagination.module.scss';

export const MyBetsModalPagination = () => {
	const sm = useBreakpoint('sm', false);

	const [totalPages, currentPage, changePage] = useUnit([
		myBetsModalModel.$totalPages,
		myBetsModalModel.pageField.$value,
		myBetsModalModel.pageField.change,
	]);

	return (
		<Pagination
			total={totalPages}
			value={currentPage}
			className={cls.myBetsModalPagination}
			size={sm ? 'md' : 'sm'}
			onChange={changePage}
		/>
	);
};
